@if (!henviser) {
  <h1 mat-dialog-title>Opret henviser</h1>
}
@if (henviser) {
  <h1 mat-dialog-title>Rediger henviser</h1>
}
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content class="align-center">
  @if (virksomhed) {
    <div>
      <strong>Fundet i CVR.</strong>
      <br />
      {{ virksomhed.name }}
      <br />
      {{ virksomhed.cvr }}
    </div>
  }
  @if (!virksomhed) {
    <div>
      <form [formGroup]="form" autocomplete="off">
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Cvr</mat-label>
            <input formControlName="cvr" matInput (keydown)="onCvrKeyDownEvent($event)" />
            <button mat-icon-button matSuffix (click)="searchByCvr()" [disabled]="!cvr.value">
              <mat-icon
                [class.blue]="cvr.value"
                class="btn-icon inline-flex"
                aria-label="Søg via CVR eller Firmanavn"
                matTooltip="Søg via CVR eller Firmanavn"
                >
                search
              </mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Navn</mat-label>
            <input formControlName="name" matInput />
          </mat-form-field>
        </div>
        <div class="form-row no-margin-bottom">
          <mat-form-field appearance="outline">
            <mat-label>Tillad oprettelse</mat-label>
            <mat-select formControlName="stamdatastatus">
              @for (status of stamdatastatusvalues; track status) {
                <mat-option [value]="status.value">{{ status.name }}</mat-option>
              }
            </mat-select>
            <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
          </mat-form-field>
        </div>
      </form>
    </div>
  }
</div>
<div mat-dialog-actions>
  @if (!henviser) {
    <button mat-raised-button color="primary" (click)="add()" [disabled]="!form.valid">Opret</button>
  }
  @if (henviser) {
    <button [disabled]="!form.valid" mat-raised-button (click)="update()">Gem</button>
  }
  <button mat-raised-button (click)="cancel()">Fortryd</button>
</div>
